// extracted by mini-css-extract-plugin
module.exports =  {"card":"card__PdbvQ","content":"content__W4fo2","header":"header__5CUjS","footer":"footer__U0ysm"};